import React, { useCallback, useMemo, useState } from 'react';
import { isIOS, isMobileSafari } from 'react-device-detect';
import { getIsPWAInstalled } from 'helpers/getIsPWAInstalled';

import { SiteConfigManager, StorageManager } from '@atlas/core';
import { Button, Icon, Label } from '@atlas/ui';

import { TEMPLATE, THEME_PATH } from 'common/constants';
import { AddToHomeScreenIOSPopup } from 'common/Popup/AddToHomeScreenIOSPopup/AddToHomeScreenIOSPopup';

export const BannerAddToHomeScreenIOS = () => {
  const [manifest, setManifest] = useState(null);
  const [isBannerWasShowed, setIsBannerWasShowed] = useState(
    JSON.parse(StorageManager.getItem('pwaBannerIsShowed')),
  );
  const [isVisiblePopup, setIsVisiblePopup] = useState(false);
  const visibleFromConfig = SiteConfigManager.getConfig('config.config.general.pwaBanner');

  const iconPath = useMemo(() => {
    const icons = manifest?.icons;
    if (!icons?.length) return null;
    const bannerIcon = icons.find(({ sizes }) => sizes === '72x72');
    return `${THEME_PATH}/${TEMPLATE}/${bannerIcon?.src || icons[0].src}`;
  }, [manifest]);

  const onCloseBannerHandler = useCallback(() => {
    StorageManager.setItem('pwaBannerIsShowed', 'true');
    setIsBannerWasShowed(true);
  }, []);

  const onOpenPopupHandler = useCallback(() => setIsVisiblePopup(true), []);
  const onClosePopupHandler = useCallback(() => setIsVisiblePopup(false), []);

  React.useEffect(() => {
    const { href } = document.querySelector('[rel=manifest]') || {};
    if (href) {
      fetch(href)
        .then(rsp => rsp.json())
        .then(obj => setManifest(obj));
    }
  }, []);

  React.useEffect(() => {
    if (getIsPWAInstalled()) {
      onCloseBannerHandler();
      return null;
    }
  }, [onCloseBannerHandler]);

  if (!isIOS || !isMobileSafari) return null;
  if (!manifest) return null;
  if (isBannerWasShowed || !visibleFromConfig) return null;

  return (
    <>
      <div className="banner-add-to-home-screen-ios">
        <Icon
          className="banner-add-to-home-screen-ios__close"
          name="close"
          onClick={onCloseBannerHandler}
        />
        {iconPath && (
          <div className="banner-add-to-home-screen-ios__icon">
            <img alt="icon" src={iconPath} />
          </div>
        )}
        <div className="banner-add-to-home-screen-ios__content">
          <div className="banner-add-to-home-screen-ios__title title-bold-text">
            {manifest.name}
          </div>
          <div className="sub-title-xsmall-300-text">
            <Label message="add_to_home_screen_text" />
          </div>
        </div>
        <Button className="banner-add-to-home-screen-ios__button" onClick={onOpenPopupHandler}>
          <Label message="add_to_home_screen_install" />
        </Button>
      </div>
      <AddToHomeScreenIOSPopup onClose={onClosePopupHandler} visible={isVisiblePopup} />
    </>
  );
};
